function e(e,t,u={}){let a;return(...i)=>{!a&&u.leading&&e(...i),clearTimeout(a),a=setTimeout(()=>e(...i),t)}}export{e as default};
